module.exports = __webpack_public_path__ + "static/img/checkbox-rounded-checked.a2211c6.png";